import { LogicService } from '../../../core/canvas-logic/base/logic-service';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { TableThumbnailLogic } from './table-thumbnail-logic';
import { ShapeThumbnailLogic } from './shape-thumbnail-logic';
import { PictureThumbnailLogic } from './picture-thumbnail-logic';
import { ConnectorThumbnailLogic } from './connector-thumbnail-logic';
import { GroupThumbnailLogic } from './group-thumbnail-logic';
import { ComponentFactory } from '../../../core/canvas-render/elements/component-factory';
import { CommonThumbnailLogic } from './common-thumbnail-logic';
import { SmartArtThumbnailLogic } from './smart-art-thumbnail-logic';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';


export class ThumbnailLogicService extends LogicService {
    declare public logicMap: Map<string, CommonThumbnailLogic>;
    public createLogic(
        factoryOptions: InterfaceFactoryOptions,
        component: ComponentFactory,
    ): CommonThumbnailLogic | null {
        const { model } = factoryOptions;
        switch (model.type) {
            case UIModelType.SHAPE:
                return new ShapeThumbnailLogic(factoryOptions as InterfaceFactoryOptions<IShapeModel>, component);
            case UIModelType.IMAGE:
                return new PictureThumbnailLogic(factoryOptions as InterfaceFactoryOptions<IPictureModel>, component);
            case UIModelType.CONNECTOR:
                return new ConnectorThumbnailLogic(
                    factoryOptions as InterfaceFactoryOptions<IConnectorModel>,
                    component,
                );
            case UIModelType.TABLE:
                return new TableThumbnailLogic(factoryOptions as InterfaceFactoryOptions<ITableModel>, component);
            case UIModelType.GROUP:
                return new GroupThumbnailLogic(factoryOptions as InterfaceFactoryOptions<IGroupModel>, component);
            case UIModelType.SMART_ART:
                return new SmartArtThumbnailLogic(factoryOptions as InterfaceFactoryOptions<ISmartArtModel>, component);
            default:
                return null;
        }
    }

    public getLogic(factoryOptions: InterfaceFactoryOptions): CommonThumbnailLogic | undefined {
        return this.logicMap.get(factoryOptions.model.key);
    }

    public removeLogic(factoryOptions: InterfaceFactoryOptions): void {
        const logic = this.getLogic(factoryOptions);
        // @ts-ignore
        logic?.videoPosterListener?.();
        // @ts-ignore
        logic?.iframePosterListener?.();

        super.removeLogic(factoryOptions);
    }
}
